<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col v-if="collapsed" :span="10" class="logo" :class="'logo-collapse-width'">{{ sysNameShort }}</el-col>
      <el-col v-show="menuShow" :span="12" class="logo" :class="'logo-width'">
        <div class="headerinfo">
          <span class="el-dropdown-link userinfo-inner">
            <img
                :src="this.headerImg"
                style="
                float: left;
                margin-left: 52px;
                width: 113px;
                height: 64px;
                margin-top: 20px;
              "
            />
          </span>
        </div>
        <span class="jnjhead" v-show="titleLogo">上海华洋保险经纪</span>
      </el-col>
      <el-col :span="12" class="userinfo">
        <span style="float:left;">
            <el-button type="primary" size="mini" round icon="el-icon-bell" style="padding: 7px 10px"
                       @click="menuShowChange">折叠/展开</el-button>
        </span>
        <span class="el-dropdown-link userinfo-inner">
<!--          <img :src="this.sysUserAvatar" style="float: right; margin-right: 10px" />-->
          <el-tag type="text" disabled="true" round style="border: none;">hi,{{ sysUserName }}!</el-tag>
        </span>
        <el-button type="primary" round size="mini" @click="updatePasswordDialog()">修改密码</el-button>
        <el-button type="primary" icon="el-icon-switch-button" round size="mini" @click="logOUt()">退出</el-button>
      </el-col>
    </el-col>
    <el-col :span="24" class="main">
      <!--导航菜单-->
      <el-aside v-show="menuShow" :style="'width:' + leftNovWidth">
        <el-menu
            id="menuClass"
            router
            unique-opened
            class="el-menu-vertical-demo"
            :default-active="$route.path"
            :collapse="collapsed"
            :collapse-transition="true"
        >
          <template v-for="navMenu in menuList">
            <el-submenu
                v-if="navMenu.children && navMenu.children.length > 0"
                :index="navMenu.menuUrl"
                :key="navMenu.menuId"
            >
              <template slot="title">
                <i :class="navMenu.menuIcon" style="color: #428bca"></i>
                <span slot="title">{{ navMenu.menuName }}</span>
              </template>

              <template v-for="navMenuSub in navMenu.children">
                <el-submenu
                    v-if="navMenuSub.children && navMenuSub.children.length > 0"
                    :index="navMenuSub.menuUrl"
                    :key="navMenuSub.menuId"
                >
                  <template slot="title">
                    <i :class="navMenuSub.menuIcon" style="color: #428bca"></i>
                    <span slot="title">{{ navMenuSub.menuName }}</span>
                  </template>
                  <el-menu-item
                      v-for="subBottom in navMenuSub.children"
                      @click="addTab(subBottom.menuName, subBottom.menuUrl)"
                      :key="subBottom.menuId"
                      :data="subBottom"
                      :index="subBottom.menuUrl"
                      :route="subBottom.menuUrl"
                  >
                    <span slot="title">{{ subBottom.menuName }}</span>
                    <!-- <span slot="title" v-if="navMenu.funcname == '机构管理'" >{{1111111111}}</span> -->
                  </el-menu-item>
                </el-submenu>
                <!--                <el-submenu-->
                <!--                    v-else-if="navMenuSub.menuName === '业务话术'"-->
                <!--                    :index="navMenuSub.menuUrl"-->
                <!--                    :key="navMenuSub.menuId"-->
                <!--                >-->
                <!--                  <template slot="title">-->
                <!--                    <i :class="navMenuSub.menuIcon" style="color: #428bca"></i>-->
                <!--                    <span slot="title">{{ navMenuSub.menuName }}</span>-->
                <!--                  </template>-->
                <!--                </el-submenu>-->
                <el-menu-item
                    v-else-if="navMenuSub.menuName === '人事通知'"
                    ref="RSTZ"
                    id="RSTZ"
                    :key="navMenuSub.menuId"
                    :data="navMenuSub.menuName"
                    :index="navMenuSub.menuUrl"
                    :route="navMenuSub.menuUrl"
                >
                  <i :class="navMenuSub.menuIcon" style="color: #428bca"></i>
                  <span slot="title">{{ navMenuSub.menuName }}</span>
                  <!-- <span slot="title" v-if="navMenu.funcname == '机构管理'" >{{1111111111}}</span> -->
                </el-menu-item>
                <el-menu-item
                    v-else
                    :key="navMenuSub.menuId"
                    :data="navMenuSub"
                    :index="navMenuSub.menuUrl"
                    :route="navMenuSub.menuUrl"
                    @click="addTab(navMenuSub.menuName, navMenuSub.menuUrl)"
                >
                  <i :class="navMenuSub.menuIcon" style="color: #428bca"></i>
                  <span slot="title">{{ navMenuSub.menuName }}</span>
                  <!-- <span slot="title" v-if="navMenu.funcname == '机构管理'" >{{1111111111}}</span> -->
                </el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item
                v-else
                :key="navMenu.menuId"
                :data="navMenu"
                :index="navMenu.menuUrl"
                :route="navMenu.menuUrl"
            >
              <i :class="navMenu.menuIcon" style="color: #428bca"></i>
              <span slot="title">{{ navMenu.menuName }}</span>
              <!-- <span slot="title" v-if="navMenu.funcname == '机构管理'" >{{1111111111}}</span> -->
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>

      <section
          class="content-container"
          style="padding: 0 10px; box-sizing: border-box"
          :style="{ width: sessionWidth }"
      >
        <el-tabs
            v-model="menuTabsValue"
            type="card"
            closable
            @tab-remove="removeTab"
            @tab-click="addNewtap(menuTabsValue)"
            :style="{ width: sessionWidth }"
        >
          <el-tab-pane
              v-for="item in menuTabs"
              :key="item.name"
              :label="item.title"
              :name="item.name"
          >
          </el-tab-pane>
          <el-tab-pane key="全部关闭" label="全部关闭" name="全部关闭">
          </el-tab-pane>
        </el-tabs>
        <el-col :span="24" class="content-wrapper">
          <transition name="fade" mode="out-in">
            <keep-alive :include="keepArrary">
              <router-view :key="key"></router-view>
            </keep-alive>
          </transition>
        </el-col>
      </section>
    </el-col>
    <update-user-password :visible="updatePassword.visible" :user-code="updatePassword.sysUserCode"
                          @close="closeDialog"></update-user-password>
  </el-row>
</template>
<script>
import NavMenu from "@/components/NavMenu";
import {getMenuList, getUserInfo} from "@/api/api";
import VueCookies from "vue-cookies";
import UpdateUserPassword from "./updateUserPassword";
// import func from '../../vue-temp/vue-editor-bridge';
export default {
  components: {UpdateUserPassword, NavMenu},
  data() {
    return {
      menuShow: true,
      //定义一个集合：左侧菜单点击后，在右边出现页签集合。
      menuTabs: [{title: "首页", name: "/index", content: "/index"}],
      //当前点中的菜单
      menuTabsValue: "/index",
      sessionWidth: "",
      //缓存数组
      keepArrary: [],
      //页面菜单
      menuList: [],
      collapsed: false,
      //元素宽度
      leftNovWidth: "248px",
      titleLogo: true,
      sysUserName: "",
      updatePassword: {
        sysUserCode: "",
        visible: false,
      },
      sysUserAvatar: require("../assets/user.png"),
      headerImg: require("../assets/logo01.png"),
    };
  },
  created() {
    let keepArrary = JSON.parse(sessionStorage.getItem("keepArrary"));
    if (keepArrary) {
      this.keepArrary = JSON.parse(sessionStorage.getItem("keepArrary"));
    }

  },
  mounted() {
    this.getHomeMenuList();
    let sysUser = JSON.parse(sessionStorage.getItem('sysUserName'));
    this.sysUserName = sysUser["staff_name"];
    this.updatePassword.sysUserCode = sysUser["staff_code"];
    this.sessionWidth = window.innerWidth - 248 + "px";
    this.menuTabsValue = JSON.parse(sessionStorage.getItem("menuTabsValue"));
    this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
    if (this.menuTabsValue == "" || this.menuTabsValue == undefined) {
      this.menuTabsValue = "/index";
    }
    if (this.menuTabs == [] || this.menuTabs == undefined) {
      this.menuTabs = [{title: "首页", name: "/index", content: "/index"}];
    }
  },
  computed: {
    key() {
      // 只要保证 key 唯一性就可以了，保证不同页面的 key 不相同
      if (this.$route.path === "/companyStandardManager") {
        return this.$route.fullPath;
      } else {
        return this.$route.path;
      }
    },
  },
  watch: {
    $route: {
      handler: function (to, from) {
        if (to.path === "/") {
        }
        if (to.fullPath.indexOf("/warrantyDetail") != -1) {
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          var flage = this.menuTabs.some((item) => {
            return item.content == to.fullPath;
          });
          if (!flage) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath,
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach((item, index) => {
            if (item.content == delTabs) {
              this.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach((item, index) => {
            if (delTabs == "/" + item) {
              this.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", JSON.stringify(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem(
              "menuTabsValue",
              JSON.stringify(this.menuTabsValue)
          );
          sessionStorage.setItem("menuTabs", JSON.stringify(this.menuTabs));
        } else if (to.fullPath.indexOf("/warrantyChange") != -1) {
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          var flage = this.menuTabs.some((item) => {
            return item.content == to.fullPath;
          });
          if (!flage) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath,
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach((item, index) => {
            if (item.content == delTabs) {
              this.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach((item, index) => {
            if (delTabs == "/" + item) {
              this.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", JSON.stringify(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem(
              "menuTabsValue",
              JSON.stringify(this.menuTabsValue)
          );
          sessionStorage.setItem("menuTabs", JSON.stringify(this.menuTabs));
        } else if (to.fullPath.indexOf("/enquiryDetail") != -1) {
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          var flage = this.menuTabs.some((item) => {
            return item.content == to.fullPath;
          });
          if (!flage) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath,
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach((item, index) => {
            if (item.content == delTabs) {
              this.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach((item, index) => {
            if (delTabs == "/" + item) {
              this.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", JSON.stringify(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem(
              "menuTabsValue",
              JSON.stringify(this.menuTabsValue)
          );
          sessionStorage.setItem("menuTabs", JSON.stringify(this.menuTabs));
        } else if (to.fullPath.indexOf("/insuranceCompany") !== -1) {
          var str = to.path.substr(1);
          if (this.keepArrary.indexOf(str) == -1) {
            this.keepArrary.push(str);
          }
          sessionStorage.setItem("keepArrary", JSON.stringify(this.keepArrary));
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          var flage = this.menuTabs.some((item) => {
            return item.content === to.fullPath;
          });
          if (!flage) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath,
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach((item, index) => {
            if (item.content == delTabs) {
              this.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach((item, index) => {
            if (delTabs == "/" + item) {
              this.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", JSON.stringify(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem(
              "menuTabsValue",
              JSON.stringify(this.menuTabsValue)
          );
          sessionStorage.setItem("menuTabs", JSON.stringify(this.menuTabs));
        } else if (to.fullPath.indexOf("/claimDetail") !== -1) {
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          let flag = this.menuTabs.some((item) => {
            return item.content === to.fullPath;
          });
          if (!flag) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath,
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach((item, index) => {
            if (item.content == delTabs) {
              this.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach((item, index) => {
            if (delTabs == "/" + item) {
              this.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", JSON.stringify(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem(
              "menuTabsValue",
              JSON.stringify(this.menuTabsValue)
          );
          sessionStorage.setItem("menuTabs", JSON.stringify(this.menuTabs));
        } else if (to.fullPath.indexOf("/claimHis") !== -1) {
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          let flag = this.menuTabs.some((item) => {
            return item.content === to.fullPath;
          });
          if (!flag) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath,
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach((item, index) => {
            if (item.content == delTabs) {
              this.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach((item, index) => {
            if (delTabs == "/" + item) {
              this.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", JSON.stringify(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem(
              "menuTabsValue",
              JSON.stringify(this.menuTabsValue)
          );
          sessionStorage.setItem("menuTabs", JSON.stringify(this.menuTabs));
        } else if (to.fullPath == "/warrantyAdd") {
          var str = to.path.substr(1);
          if (this.keepArrary.indexOf(str) == -1) {
            this.keepArrary.push(str);
          }
          sessionStorage.setItem("keepArrary", JSON.stringify(this.keepArrary));
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          var flage = this.menuTabs.some((item) => {
            return item.content == to.fullPath;
          });
          if (!flage) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath,
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach((item, index) => {
            if (item.content == delTabs) {
              this.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach((item, index) => {
            if (delTabs == "/" + item) {
              this.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", JSON.stringify(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem(
              "menuTabsValue",
              JSON.stringify(this.menuTabsValue)
          );
          sessionStorage.setItem("menuTabs", JSON.stringify(this.menuTabs));
        } else {
          var str = to.path.substr(1);
          if (this.keepArrary.indexOf(str) == -1) {
            this.keepArrary.push(str);
          }
          sessionStorage.setItem("keepArrary", JSON.stringify(this.keepArrary));
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          var flage = this.menuTabs.some((item) => {
            return item.content == to.fullPath;
          });
          if (!flage) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath,
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach((item, index) => {
            if (item.content == delTabs) {
              this.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach((item, index) => {
            if (delTabs == "/" + item) {
              this.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", JSON.stringify(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem(
              "menuTabsValue",
              JSON.stringify(this.menuTabsValue)
          );
          sessionStorage.setItem("menuTabs", JSON.stringify(this.menuTabs));
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    menuShowChange() {
      this.menuShow = !this.menuShow;
    },
    //修改密码
    updatePasswordDialog() {
      this.updatePassword.visible = true;
    },
    closeDialog() {
      this.updatePassword.visible = false;
    },
    logOUt() {
      this.$confirm("是否确认退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        sessionStorage.clear();
        localStorage.clear();
        this.$cookies.remove("access_token");
        location.href = process.env.API_FRONT_ROOT;
        this.$message({
          type: "success",
          message: "退出成功!",
        });
      });
    },
    getHomeMenuList() {
      getMenuList({}).then((res) => {
        if (res.success) {
          this.menuList = res.data;
          sessionStorage.setItem("menuList", JSON.stringify(this.menuList));

          this.$nextTick(() => {
            //计算菜单样式
            let node = document.getElementById("RSTZ");
            node.style.setProperty('padding-left', node.style.paddingLeft, 'important');
            node.style.setProperty('color', "#303133");
            node.style.setProperty('font-size', "14px", 'important');
          });
        }
      }).catch((res) => {
        this.$message("查询异常");
      });
    },
    subClick(child) {
      if (child.subFunc && child.subFunc.length > 0) {
        $router.push(child.routeurl);
      }
    },
    //添加tab页签
    addTab(targetName, contentUrl) {
      let str = contentUrl.substring(1);

      if (this.keepArrary.indexOf(str) === -1) {
        this.keepArrary.push(str);
      }
      sessionStorage.setItem("keepArrary", JSON.stringify(this.keepArrary));
      //console.log("targetName==" + targetName + ",contentUrl=" + contentUrl);
      //设置页签唯一标识符=标题名称+链接
      let newTabName = contentUrl;
      //先判断是否已经打开
      let tabs = this.menuTabs;
      var isOpen = false;
      tabs.forEach((tab, index) => {
        //查找是否已经打开。
        if (tab.name === newTabName) {
          //设置选中
          isOpen = true;
        }
      });

      //如果没被打开,设置一个新的页签
      if (!isOpen) {
        this.menuTabs.push({
          title: targetName,
          name: contentUrl,
          content: contentUrl,
        });
      }

      this.menuTabsValue = contentUrl;
      sessionStorage.setItem(
          "menuTabsValue",
          JSON.stringify(this.menuTabsValue)
      );
      sessionStorage.setItem("menuTabs", JSON.stringify(this.menuTabs));
    },
    // 移除tab页签
    removeTab(targetName) {
      let remove = "";
      this.keepArrary.forEach((item, index) => {
        let pattern = new RegExp("^/" + item);
        if (pattern.test(targetName)) {
          this.keepArrary.splice(index, 1);
          remove = "/" + item;
        }
      });

      sessionStorage.setItem("keepArrary", JSON.stringify(this.keepArrary));

      let pathList = this.$root.pathList;
      let routesNumMap = this.$root.routesNumMap;
      let path = pathList.find(e => {
        let pattern = new RegExp("^" + e);
        if (pattern.test(targetName))
          return e;
      });

      if (path) {
        let pattern = new RegExp("^" + path);
        path = path.substring(1);
        let arr = this.$router.options.routes[routesNumMap[path]["number"]].children;

        //移除路由节点
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].path === remove) {
            arr.splice(i, 1);
          }
        }

        //移除本地存储
        let routeNum = JSON.parse(sessionStorage.getItem(routesNumMap[path]["routeName"]));
        if (routeNum) {
          routeNum = routeNum.filter((item) => {
            return item.path !== remove;
          });
          sessionStorage.setItem(routesNumMap[path]["routeName"], JSON.stringify(routeNum));
        }
      }

      let tabs = this.menuTabs;
      let activeName = this.menuTabsValue;
      //console.log("activeName==" + activeName + ",targetName=" + targetName);
      //首页禁止关闭
      if (targetName === "/index") return;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.menuTabsValue = activeName;
      if (this.menuTabsValue)
        this.menuTabs = tabs.filter((tab) => tab.name !== targetName);
      this.$router.push({path: this.menuTabsValue});
      sessionStorage.setItem(
          "menuTabsValue",
          JSON.stringify(this.menuTabsValue)
      );
      sessionStorage.setItem("menuTabs", JSON.stringify(this.menuTabs));
    },
    //tab页面点击事件
    addNewtap(targetName) {
      if (targetName === "全部关闭") {
        this.menuTabs = [{title: "首页", name: "/index", content: "/index"}];
        this.menuTabsValue = "/index";
        sessionStorage.setItem(
            "menuTabsValue",
            JSON.stringify(this.menuTabsValue)
        );
        sessionStorage.setItem("menuTabs", JSON.stringify(this.menuTabs));
        this.keepArrary = [];
        sessionStorage.setItem("keepArrary", JSON.stringify(this.keepArrary));
        this.$router.push({path: "/index"});
      } else {
        this.$router.push({path: targetName});
      }
    },
    onSubmit() {
    },
    handleopen() {
      //console.log('handleopen');
    },
    handleclose() {
      //console.log('handleclose');
    },
    handleselect: function (a, b) {
    },
    //退出登录
    gochangpwel: function () {
      var _this = this;
      this.$confirm("确认修改密码吗?", "提示", {
        //type: 'warning'
      })
          .then(() => {
            _this.$router.push("/changpwd");
          })
          .catch(() => {
          });
    },
    goQiantai: function () {
      window.location.href = "../html/jnIndex.html?v=2020041901";
    },
    //折叠导航栏
    collapse: function () {
      this.collapsed = !this.collapsed;
      if (this.collapsed) {
        // this.titleLogo = false;

        this.leftNovWidth = "64px";
      } else {
        this.leftNovWidth = "220px";
        this.titleLogo = true;
      }
    },
    showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName(
          "submenu-hook-" + i
      )[0].style.display = status ? "block" : "none";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~scss_vars";

.showNov {
  background-color: #428bca;
  color: #fff;
}

.el-dropdown-menu.el-popper {
  top: 40px !important;
}

.el-button:active {
  border-color: #fff;
  outline: 0;
  background-color: #428bca;
  color: #fff;
}

.jnjhead {
  font-size: 24px;
  color: #085299;
  font-weight: bold;
  position: absolute;
  top: 95px;
  left: 26px;
}

.jnjhead > span {
  font-weight: normal;
  margin-left: 5px;
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover,
.dqwz {
  color: #000;
  font-weight: bold;
}

.el-scrollbar-self {
  width: 100%;
  height: 100%;
}

.xiegang {
  margin: 0 9px;
  // font-weight: 700;
  color: #c0c4cc;
}

/* 解决饿了么ui 滚动闪烁BOG */
.el-table__footer-wrapper,
.el-table__header-wrapper {
  overflow: auto;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 100%;
  // min-height: 400px;
  overflow-y: auto;
}

.el-submenu > > > .el-menu-item-group__title {
  padding: 0;
}

.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;

  .header {
    height: 72px;
    line-height: 72px;
    //background: #428BCA;
    background: #fff;
    box-shadow: 0px 4px 20px rgba(40, 122, 198, 0.101960784313725);
    color: #fff;

    .userinfo {
      text-align: right;
      padding-right: 35px;
      float: right;

      .userinfo-inner {
        cursor: pointer;
        color: #555;

        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 0px 10px 10px;
          float: right;
        }
      }
    }

    .headerinfo {
      text-align: left;
      padding-left: 12px;
      float: left;

      .userinfo-inner {
        cursor: pointer;
        color: #fff;

        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 5px 10px 10px;
          float: left;
        }
      }
    }

    .logo {
      //width:230px;
      height: 60px;
      // border-color: rgba(238, 241, 146, 0.3);
      // border-right-width: 1px;
      // border-right-style: solid;
      img {
        width: 40px;
        float: left;
        margin: 10px 10px 10px 18px;
      }

      .txt {
        color: #fff;
      }
    }

    .logo-width {
      font-size: 18px;
      font-weight: 800;
      width: 248px;
      height: 164px;
      border-bottom: 1px solid #fcf7f7;
      background-color: #fff;
      overflow: hidden;
      box-shadow: 4px 0px 20px rgba(40, 122, 198, 0.101960784313725);
    }

    .logo-collapse-width {
      padding-left: 10px;
      padding-right: 10px;
      font-size: 18px;
      width: 64px;
    }

    .tools {
      padding: 0px 23px;
      width: 14px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
  }

  .main {
    display: flex;
    position: absolute;
    top: 164px;
    bottom: 0px;
    // overflow: hidden;
    // box-shadow: 4px 0px 20px rgba(40, 122, 198, 0.101960784313725);
    .content-container {
      flex: 1;
      overflow-y: visible;
      padding: 2px;
      background: #f5f7fa1f;
      position: relative;

      .breadcrumb-container {
        background: #fff;
        padding: 10px 5px;
        position: absolute;
        top: 0;
        left: 0;

        .breadcrumb-inner {
          float: left;
        }
      }

      .content-wrapper {
        box-sizing: border-box;
        padding: 7px;
      }
    }
  }
}

//表格样式
</style>



// WEBPACK FOOTER //
// Home.vue?5aa32f6b